import React from 'react';
import { Link } from 'react-router-dom';

const PageNotFound: React.FC = () => {
    return (
        <>
            {/* content */}
            <div className="coverimg h-100 w-100 top-0 start-0 position-absolute z-index-0 opacity-25">
                <img src={asset('assets/img/adminuiux/notfound.jpg')} alt="" />
            </div>
            <div className="row justify-content-center align-items-center vh-100 position-relative z-index-1">
                <div className="col-12 col-md-9 col-lg-8 col-xl-7 text-center py-3 py-lg-4 maxwidth-dynamic" style={{ '--mw-dynamic': '700px' } as React.CSSProperties}>

                    <div className="row align-items-center justify-content-center text-center">
                        <div className="col-auto">
                            <h1 className="fw-bold text-theme-1 theme-red" style={{ fontSize: '140px' } as React.CSSProperties}>4<i className="bi bi-wrench-adjustable-circle mx-2"></i>4</h1>
                            <h1 className="fw-bold mb-0">Something went wrong!</h1>
                            <h4 className="">Link is broken or page removed</h4>
                            <p className="small mb-4">The page doesn't exist or removed.<br />Please check url or we suggest to go back home</p>

                            <Link to="/app/dashboard" className="btn btn-light"><i className="bi bi-arrow-left"></i> Back to home </Link>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
};

export default PageNotFound;
